import { render, staticRenderFns } from "./FavoritesRepairs.vue?vue&type=template&id=5d4b41eb&scoped=true&"
import script from "./FavoritesRepairs.vue?vue&type=script&lang=js&"
export * from "./FavoritesRepairs.vue?vue&type=script&lang=js&"
import style0 from "./FavoritesRepairs.vue?vue&type=style&index=0&id=5d4b41eb&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d4b41eb",
  null
  
)

export default component.exports